import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AuthService } from 'src/app/services/authenticate.service';
import { NotificationService } from 'src/app/services/notification.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { PasswordValidator } from '../management/manage_user/add_user/password.validator';

@Component({
    selector: 'app-reset_password',
    templateUrl: 'reset_password.component.html',
    styleUrls: ['reset_password.component.css'],
    standalone: false
})
export class Reset_passwordComponent {
  form: FormGroup = new FormGroup({});
  showForgotPassword: boolean = false;
  token: string = '';
  passwordChanged: Boolean = false;
  constructor(private authService: AuthService,
    private router: Router
    , private toast: NotificationService
    , private loader: LoaderService
    , private activeRoute: ActivatedRoute,) {

    this.activeRoute.params.subscribe((params: Params) => {
      if (Object.keys(params).length > 0) {
        if (params['token'] != null) {
          this.token = params['token'];
        }
      }
    });

    this.initiateFormGroup();
  }

  initiateFormGroup() {
    this.form = new FormGroup({
      'password': new FormControl("", [Validators.required, PasswordValidator.strong]),
      'confirmpassword': new FormControl("", [Validators.required]),
    })
  }

  comparePassword() {
    let data = this.form.value;
    if (data.password !== data.confirmpassword) {
      this.toast.showError("New password and compare password should be same");
      return false;
    }
    return true;
  }

  submitPage() {
    this.passwordChanged = false;
    if (this.validatePage() && this.comparePassword()) {
      this.loader.start();
      let request: any = {};
      request.token = this.token;
      request.newPassword = this.form.get("password")?.value;
      this.authService.resetPassword(request).subscribe(res => {
        this.loader.stop();
        sessionStorage.clear();
        this.passwordChanged = true;
      },
        (error: any) => {
          this.loader.stop();
          this.toast.showException(error.error);
        })
    }
  }

  reset() {
    this.form.patchValue({
      "password": '',
      "confirmpassword": '',
    })
    Object.keys(this.form.controls).forEach(key => {
      if (key !== null) {
        this.form.get(key)?.clearValidators()
      }
    })
  }

  validatePage(): boolean {
    Object.keys(this.form.controls).forEach(key => {
      if (key !== null) {
        this.form.get(key)?.markAsDirty();
        this.form.get(key)?.markAsTouched();
      }
    })
    return this.form.valid;
  }
}